
import React from "react";
import Header from "@/components/page/Header";
import TabsNavigation from "@/components/page/TabsNavigation";
import { type MovieListName } from "@/hooks/search/types/listConstants";

interface AppHeaderProps {
  currentTab: MovieListName;
  viewMode: "grid" | "list";
  onTabChange: (value: MovieListName) => void;
  onViewModeChange: (mode: "grid" | "list") => void;
  registerSearchInput?: (ref: HTMLInputElement | null) => void;
  onOpenMovieDetails?: (tmdbId: number) => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({
  currentTab,
  viewMode,
  onTabChange,
  onViewModeChange,
  registerSearchInput,
  onOpenMovieDetails
}) => {
  return (
    <div className="sticky top-0 z-50 bg-mono-eerieBlack shadow-md">
      <Header 
        registerSearchInput={registerSearchInput}
        onOpenMovieDetails={onOpenMovieDetails}
      />
      <TabsNavigation 
        currentTab={currentTab} 
        viewMode={viewMode} 
        onViewModeChange={onViewModeChange}
        onTabChange={onTabChange}
      />
      
      <div className="h-3 md:h-4 w-full bg-gradient-to-b from-mono-eerieBlack to-transparent absolute bottom-0 translate-y-full pointer-events-none"></div>
    </div>
  );
};

export default AppHeader;
